// delta-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "%{arg1} (%{arg2})": "%{arg1} (%{arg2})",
    "%{arg1} cupom(ns) da seleção já está(ão) resgatado(s) ou estornado(s) e será(ão) ignorado(s).": "%{arg1} cupón(es) de la selección ya está(n) canjeado(s) o revertido(s) y será(n) ignorado(s).",
    "%{arg1}%": "%{arg1}%",
    "%{arg1}: %{arg2}, %{arg3}": "%{arg1}: %{arg2}, %{arg3}",
    "(horário de Brasília)": "(horario de Brasilia)",
    "0 6px 20px rgba(118,75,162,0.45)": "0 6px 20px rgba(118,75,162,0.45)",
    "0,00 l": "0,00 l",
    "0.82rem": "0.82rem",
    "0.8s": "0.8s",
    "1.6s": "1.6s",
    "10px": "10px",
    "1px 5px": "1px 5px",
    "1px solid #f59e0b": "1px solid #f59e0b",
    "20px 0 20px 0": "20px 0 20px 0",
    "20px 20px 20px 4px": "20px 20px 20px 4px",
    "4px": "4px",
    "6px 0": "6px 0",
    "8px 10px": "8px 10px",
    "999px": "999px",
    "Adicionar cupom para o cliente": "Agregar cupón para el cliente",
    "Adicionar pontos para o cliente": "Agregar puntos para el cliente",
    "Anúncio desativado": "Anuncio desactivado",
    "Aprenda a criar e gerenciar descontos de combustível para seus clientes.": "Aprenda a crear y gestionar descuentos de combustible para sus clientes.",
    "Auto correção com IA": "Autocorrección con IA",
    "Bloquear": "Bloquear",
    "Bolão": "Quiniela",
    "Brinde desativado": "Premio desactivado",
    "CNPJ Inválido": "CNPJ inválido",
    "CPF Inválido": "CPF inválido",
    "CPF do frentista": "CPF del playero",
    "Cadastre jogos pontuais (Copa, finais, clássicos) e premie clientes que acertarem o placar exato — integrado ao Clube de Vantagens.": "Registre partidos puntuales (Copa, finales, clásicos) y premie a los clientes que adivinen el resultado exacto — integrado con el Club de Beneficios.",
    "ColorInput-popup": "ColorInput-popup",
    "Como Criar um Desconto": "Cómo crear un descuento",
    "Considerar novamente": "Considerar nuevamente",
    "Continuar escrevendo com IA": "Continuar escribiendo con IA",
    "DD/MM/AAAA": "DD/MM/AAAA",
    "DD/MM/AAAA HH:mm": "DD/MM/AAAA HH:mm",
    "Dashboard que combina a nota do cliente, a leitura da IA sobre os comentários e os pollItems selecionados — revelando risco silencioso, destaques, tendências e alertas automáticos.": "Panel que combina la calificación del cliente, el análisis de la IA sobre los comentarios y los pollItems seleccionados — revelando riesgo silencioso, aspectos destacados, tendencias y alertas automáticas.",
    "Desativar anúncio": "Desactivar anuncio",
    "Desativar brinde": "Desactivar premio",
    "Desativar desconto": "Desactivar descuento",
    "Desbloquear": "Desbloquear",
    "Desconto desativado": "Descuento desactivado",
    "Deve conter 50 caracteres": "Debe contener 50 caracteres",
    "EXPORTAR %{arg1}": "EXPORTAR %{arg1}",
    "Encurtar com IA": "Acortar con IA",
    "Entenda cada bloco do Painel 360 e o que fazer com ele: alertas acionáveis, pulso do período, ciclo de vida e receita em risco, economia de pontos, penetração do app na pista e ferramentas de engajamento — tudo comparado com o período anterior.": "Comprenda cada bloque del Panel 360 y qué hacer con él: alertas procesables, pulso del período, ciclo de vida e ingresos en riesgo, ahorro de puntos, penetración de la aplicación en la playa y herramientas de participación — todo comparado con el período anterior.",
    "Entenda como criar quadros de metas, configurar regras e monitorar o desempenho dos frentistas.": "Comprenda cómo crear tableros de objetivos, configurar reglas y monitorear el desempeño de los playeros.",
    "Entenda como funcionam as campanhas de recompensas, regras, produtos e conquistas.": "Comprenda cómo funcionan las campañas de recompensas, reglas, productos y logros.",
    "Entenda como funcionam as pontuações padrão e especial, fatores, prioridades e bônus.": "Comprenda cómo funcionan las puntuaciones estándar y especial, factores, prioridades y bonos.",
    "Envio de notificação": "Envío de notificación",
    "Envio pausado: nenhum disparo será feito enquanto estiver pausado.": "Envío en pausa: no se realizará ningún envío mientras esté pausado.",
    "Esta semana": "Esta semana",
    "Este mês": "Este mes",
    "Hoje": "Hoy",
    "Ignorar": "Ignorar",
    "Ignorar Sempre": "Ignorar siempre",
    "Inscrição Estadual Inválida": "Inscripción Estadual inválida",
    "Inválido": "Inválido",
    "Lat: %{arg1}, Lng: %{arg2}": "Lat: %{arg1}, Lng: %{arg2}",
    "Manual - %{arg1}": "Manual - %{arg1}",
    "Marcar %{arg1} cupom(ns) selecionado(s) como resgatado(s) agora?": "¿Marcar %{arg1} cupón(es) seleccionado(s) como canjeado(s) ahora?",
    "Marcar como lida": "Marcar como leída",
    "Marcar como não lida": "Marcar como no leída",
    "Marcar como não resolvida": "Marcar como no resuelta",
    "Marcar como resolvida": "Marcar como resuelta",
    "Nenhum envio cabe no período: a data final termina antes do próximo horário de envio.": "Ningún envío cabe en el período: la fecha final termina antes del próximo horario de envío.",
    "Nome completo": "Nombre completo",
    "O cadastro e gerenciamento de brindes não é mais feito na edição de produto. Acesse o menu": "El registro y la gestión de premios ya no se hace desde la edición de producto. Acceda al menú",
    "O campo não pode conter espaços em banco": "El campo no puede contener espacios en blanco",
    "O horário de hoje já passou. Próximo envio: %{arg1}.": "El horario de hoy ya pasó. Próximo envío: %{arg1}.",
    "O total de %{arg1} registros foram importados": "Se importaron un total de %{arg1} registros",
    "Pertence a um relatório de abastecimentos": "Pertenece a un reporte de cargas de combustible",
    "Ponto %{arg1} - Clique para remover": "Punto %{arg1} - Haga clic para quitar",
    "Pontuações Especiais": "Puntuaciones Especiales",
    "Próximo": "Siguiente",
    "Próximo envio: %{arg1}.": "Próximo envío: %{arg1}.",
    "Próximo envio: %{arg1}. Salve antes desse horário — depois disso, %{arg2}.": "Próximo envío: %{arg1}. Guarde antes de ese horario — después de eso, %{arg2}.",
    "Página Anterior": "Página anterior",
    "Slide %{arg1}": "Diapositiva %{arg1}",
    "Valor Total:": "Valor total:",
    "absolute": "absolute",
    "adicionado à": "agregado a",
    "adicionar cliente à": "agregar cliente a",
    "block": "block",
    "blur(0.5px)": "blur(0.5px)",
    "body1": "body1",
    "body2": "body2",
    "bold": "bold",
    "caption": "caption",
    "center": "center",
    "chains/chainId/potencial-frauds": "chains/chainId/potencial-frauds",
    "conic-gradient(from 0deg, #667eea, #ec4899, #f59e0b, #34d399, #667eea)": "conic-gradient(from 0deg, #667eea, #ec4899, #f59e0b, #34d399, #667eea)",
    "cpf": "cpf",
    "dd/MM/yyyy HH:mm": "dd/MM/yyyy HH:mm",
    "determinate": "determinate",
    "discount": "discount",
    "error": "error",
    "error.main": "error.main",
    "flex": "flex",
    "fraud": "fraud",
    "h6": "h6",
    "hidden": "hidden",
    "identificacao": "identificacao",
    "increase": "increase",
    "inherit": "inherit",
    "linear-gradient(135deg, #34d399, #667eea)": "linear-gradient(135deg, #34d399, #667eea)",
    "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #ec4899 100%)": "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #ec4899 100%)",
    "linear-gradient(135deg, #667eea, #764ba2)": "linear-gradient(135deg, #667eea, #764ba2)",
    "linear-gradient(135deg, #f59e0b, #ec4899)": "linear-gradient(135deg, #f59e0b, #ec4899)",
    "linear-gradient(90deg, transparent, rgba(255,255,255,0.55), transparent)": "linear-gradient(90deg, transparent, rgba(255,255,255,0.55), transparent)",
    "nenhum envio cabe mais no período": "ningún envío cabe más en el período",
    "nome": "nome",
    "none": "none",
    "nowrap": "nowrap",
    "number": "number",
    "para criar e gerenciar seus brindes.": "para crear y gestionar sus premios.",
    "pointer": "pointer",
    "radial-gradient(farthest-side, transparent calc(100% - 6px), #000 calc(100% - 5px))": "radial-gradient(farthest-side, transparent calc(100% - 6px), #000 calc(100% - 5px))",
    "remover cliente da": "quitar cliente de",
    "removido da": "quitado de",
    "small": "small",
    "standard": "standard",
    "subtitle2": "subtitle2",
    "success": "success",
    "success.main": "success.main",
    "transform 0.2s ease": "transform 0.2s ease",
    "translateY(-50%)": "translateY(-50%)",
    "translateY(-50%) scale(1.04)": "translateY(-50%) scale(1.04)",
    "warning": "warning",
    "white": "white",
    "{{nome_do_cliente}}": "{{nombre_del_cliente}}",
    "Última semana": "Última semana",
    "Último ano": "Último año",
    "Último mês": "Último mes",
    "Últimos 30 dias": "Últimos 30 días",
    "Últimos 6 meses": "Últimos 6 meses",
    "Últimos 7 dias": "Últimos 7 días",
    "❌ Não foi possível identificar a rede. Faça login novamente ou entre em contato com o suporte.": "❌ No fue posible identificar la red. Inicie sesión nuevamente o comuníquese con soporte.",
    "❌ Selecione uma rede na barra superior para usar o assistente de suporte.": "❌ Seleccione una red en la barra superior para usar el asistente de soporte.",
};

export default catalogo;
